export const GET_PLAYER = 'GET_PLAYER';
export const GET_PLAYER_SUCCESS = 'GET_PLAYER_SUCCESS';
export const GET_PLAYER_FAILED = 'GET_PLAYER_FAILED';

export const GET_PLAYER_LIST = 'GET_PLAYER_LIST';
export const GET_PLAYER_LIST_SUCCESS = 'GET_PLAYER_LIST_SUCCESS';
export const GET_PLAYER_LIST_FAILED = 'GET_PLAYER_LIST_FAILED';

export const GET_DETAILED_CAMPAIGN = 'GET_DETAILED_CAMPAIGN';
export const GET_DETAILED_CAMPAIGN_SUCCESS = 'GET_DETAILED_CAMPAIGN_SUCCESS';
export const GET_DETAILED_CAMPAIGN_FAILED = 'GET_DETAILED_CAMPAIGN_FAILED';
